import React from "react";
import "../laserBackground.css";

/**
 * Shared full-page laser grid background — identical to Page 1.
 * Drop inside any page that needs the electric grid aesthetic.
 * position: fixed so it doesn't affect page scroll/layout.
 */
const LaserBackground = () => (
  <>
    <div className="lb-container">
      <div className="lb-grid lb-top" />
      <div className="lb-grid lb-bottom" />
    </div>
    <div className="lb-center-glow" />
  </>
);

export default LaserBackground;
